import React from "react";

const WORDS = [
  "Integrity", "Transparency", "Quality Assurance", "Global Trade",
  "Reliability", "Long-Term Partnerships",
];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-navy-deep py-8"
    >
      <div className="marquee-track">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-3xl md:text-5xl font-light text-white/90 px-8">
              {w}
            </span>
            <span className="text-gold text-2xl md:text-4xl">&bull;</span>
          </span>
        ))}
      </div>
    </div>
  );
};
